module.exports = __webpack_public_path__ + "img/164w.80e55a3.jpg";